import { call, put, select } from 'redux-saga/effects';

import * as actions from './personal-notes.actions';
import * as personalNoteResourceService from '../../../resource/personal-note/personal-note.saga-service';

import { personalNotesPageSelectors } from './personal-notes.selectors';

import { IPersonalNote, IPersonalNoteUpdate } from '../../../resource/personal-note/personal-note.types';

export function* clearPersonalNotes() {
  yield put(actions.clearPersonalNotes());
}

export function* setupPersonalNotes() {
  const noteIds = (yield call(personalNoteResourceService.searchPersonalNotes)) as IPersonalNote['id'][];

  yield put(noteIds ? actions.storePersonalNotes(noteIds) : actions.clearPersonalNotes());
}

export function* createPersonalNote() {
  const note = (yield call(personalNoteResourceService.createPersonalNote)) as IPersonalNote;

  if (!note) {
    return;
  }

  yield call(setupPersonalNotes);

  return note;
}

export function* updatePersonalNote(noteId: IPersonalNote['id'], noteInfo: IPersonalNoteUpdate) {
  const note = (yield call(personalNoteResourceService.updatePersonalNote, noteId, noteInfo)) as IPersonalNote;

  if (!note) {
    return;
  }

  if (noteInfo.sort !== undefined) {
    yield call(setupPersonalNotes);
    return note;
  }

  const noteIds: IPersonalNote['id'][] = yield select(personalNotesPageSelectors.selectPersonalNotesIds);

  yield put(noteIds ? actions.storePersonalNotes([...noteIds]) : actions.clearPersonalNotes());
}

export function* deletePersonalNote(noteId: IPersonalNote['id']) {
  yield call(personalNoteResourceService.deletePersonalNote, noteId);
  yield call(personalNoteResourceService.clearPersonalNote, noteId);

  const noteIds: IPersonalNote['id'][] = yield select(personalNotesPageSelectors.selectPersonalNotesIds);

  yield put(noteIds ? actions.storePersonalNotes(noteIds.filter((id) => noteId !== id)) : actions.clearPersonalNotes());
}

export function* clearPersonalNotesPageStorage() {
  yield put(actions.clearPersonalNotes());
}
